import { endpoints } from "../constants/endpoints";
import { api } from "./api";

type FetchUserByEmailProps = {
  emailId: string;
};

export const fetchUsersByEmail = async (props: FetchUserByEmailProps) => {
  const endpointsUrl = `${endpoints.getUserByEmail}/${props.emailId}`;
  try {
    return await api.get(endpointsUrl);
  } catch (error) {
    throw new Error("Failed to fetch seller");
  }
};
